import { render } from "./DetailMgtable.vue?vue&type=template&id=58944c2b&scoped=true"
import script from "./DetailMgtable.vue?vue&type=script&lang=js"
export * from "./DetailMgtable.vue?vue&type=script&lang=js"

import "./DetailMgtable.vue?vue&type=style&index=0&id=58944c2b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-58944c2b"

export default script